import React, { useEffect, useMemo, useState } from "react";
import {
  getMondaySlugsDetails,
  getLastUsedAccountSlug,
  getMondayFullUrlForSlug
} from "services/monday-platform/existing-accounts-service";
import RegularButton from "segments/desktop/core-components/button/regular-button/regular-button";
import { LOGIN_PAGE_LINK } from "constants/links";
import PictureComponent from "/components/core/picture/picture-component";
import { LG } from "components/core/new-button/button-component";
import { trackEvent } from "/services/bigbrain-service";
import { WELCOME_PAGE_DIDNT_FIND_ACCOUNT_CLICKED } from "constants/bigbrain-event-types";

import { componentStyles } from "./welcome-back-homepage-first-fold-component.scss";

const WelcomeBackHomepageFirstFoldComponent = (props) => {
  const { translate, translateWithParam } = props;

  const [slugsDetails, setslugsDetails] = useState([]);
  const [lastSlug, setlastSlug] = useState(null);

  useEffect(() => {
    const slugsDetailsFromCookie = getMondaySlugsDetails();
    const lastSlugFromCookie = getLastUsedAccountSlug();
    setslugsDetails(slugsDetailsFromCookie);
    setlastSlug(lastSlugFromCookie);
  }, []);

  const lastSlugDetails = useMemo(() => {
    return slugsDetails.find((slugDetail) => slugDetail?.slug === lastSlug);
  }, [lastSlug, slugsDetails]);

  const olderSlugDetails = useMemo(() => {
    return slugsDetails.filter((slugDetail) => slugDetail?.slug !== lastSlug);
  }, [lastSlug, slugsDetails]);

  const normalizeString = (str) => {
    return str?.replaceAll("+", " "); // platform saves the name of the user with a + instead of space
  };

  const renderLastAccountBox = () => {
    if (!lastSlugDetails) return null;

    return (
      <div className="last-account-details-box">
        <div className="last-account-title">
          {translateWithParam("welcomeBackComponent.hello", normalizeString(lastSlugDetails?.user_name))}
        </div>
        <div className="last-account-details">
          <div className="user-image-wrapper">
            <PictureComponent className="user-image" src={lastSlugDetails?.user_image} />
          </div>
          <div className="last-account-user-details">{`${lastSlugDetails?.user_email} | ${normalizeString(
            lastSlugDetails?.account_name
          )}`}</div>
          <div className="last-account-button-wrapper">
            <RegularButton
              buttonText={translate("welcomeBackComponent.goToAccount")}
              url={getMondayFullUrlForSlug(lastSlugDetails?.slug)}
              isOpenLinkInNewTab={false}
              buttonSize={LG}
            />
          </div>
        </div>
      </div>
    );
  };
  const renderAccountBox = (slugDetails) => {
    return (
      <div className="account-box">
        <div className="account-box-data">
          <div className="old-account-image-wrapper">
            <PictureComponent className="old-account-user-image" src={slugDetails?.user_image} />
          </div>
          <div className="old-account-user-details">{`${slugDetails?.user_email} | ${normalizeString(
            slugDetails?.account_name
          )}`}</div>
          <div className="old-account-button-wrapper">
            <RegularButton
              buttonText={translate("welcomeBackComponent.goToAccount")}
              url={getMondayFullUrlForSlug(slugDetails?.slug)}
              isOpenLinkInNewTab={false}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderOlderAccountBoxes = () => {
    if (olderSlugDetails.length === 0) return null;

    return (
      <div className="older-account-boxes-wrapper">
        {olderSlugDetails.map((slugDetails) => renderAccountBox(slugDetails))}
      </div>
    );
  };

  const onNoAccountClicked = () => {
    trackEvent(WELCOME_PAGE_DIDNT_FIND_ACCOUNT_CLICKED, { info1: slugsDetails.length });
  };

  const renderLoginOption = () => {
    return (
      <>
        <span className="no-account-text">{translate("welcomeBackComponent.notSeeingAccount")}</span>
        <a className="no-account-link" href={LOGIN_PAGE_LINK} onClick={onNoAccountClicked}>
          {translate("welcomeBackComponent.clickHere")}
        </a>
      </>
    );
  };

  return (
    <div className="welcome-back-homepage-first-fold-component">
      <div className="last-account-wrapper">{renderLastAccountBox()}</div>
      <div className="rest-accounts-wrapper">{renderOlderAccountBoxes()}</div>
      <div className="general-login-wrapper">{renderLoginOption()}</div>

      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default WelcomeBackHomepageFirstFoldComponent;
